import React, { Component, Children, cloneElement } from 'react'
import { withStyles } from '@material-ui/core/styles'
import PaymentNow from "./PaymentNow";
import Wrapper from "../wrapper";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {GaMenu} from "../app-icon/Icons";
import MenuList from "@material-ui/core/MenuList";

const styles = theme => ({
  licenseExpiredBox: {
    position: 'relative',
    width: '100%',
    height: 66,
    backgroundColor: 'rgb(255, 78, 68)',
    zIndex: 100,
  },
  licenseExpiredToolBar: {
    margin: '0 auto',
    maxWidth: 1072,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: 18,
    '& a': {
      color: '#fff',
      fontWeight: 'bold',
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
})

const ActionsForUsing = ({ message }) => {
  return (
    <div>
      <a href="/profile">{message}</a>
    </div>
  )
}

export { ActionsForUsing }

class LicenseExpired extends Component {
  state = {
    licenseExpired: window.state.licenseExpired,
    card: window.state.card,
    lastPayment: window.state.lastPayment,
    expirationDate: window.state.license.expirationDate,
    hasActiveGDS: window.state.hasActiveGDS,
  }
  render() {
    const { classes } = this.props
    const { licenseExpired, card, expirationDate, hasActiveGDS } = this.state

    if (!licenseExpired && hasActiveGDS) {
      return null
    }
console.log(hasActiveGDS);
    let message
    let text
    if (card) {
      if (!card.autoPay) {
        message = `включите автоплатеж`
      } else {
        message = `проверьте карту`
      }
    } else {
      message = `добавьте карту`
    }

    return (
      <div>
        {licenseExpired && (
          <div className={classes.licenseExpiredBox}>
            <div className={classes.licenseExpiredToolBar}>
                {`Лицензия закончилась ${expirationDate}, чтобы продолжить использовать ROMI center -`}
                {Children.map(this.props.children, child =>
                  cloneElement(child, { message })
                )}
            </div>
          </div>
        )}
        {!hasActiveGDS && (
          <div className={classes.licenseExpiredBox}>
            <div className={classes.licenseExpiredToolBar}>
                  <a href="/gds">
                    <span>{`В разделе “Отчеты GDS” необходима оплата. Передача данных в отчеты приостановлена`}</span>
                  </a>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default withStyles(styles)(LicenseExpired)
